import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Sidebar = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <mask id='path-1-inside-1_34544_90440' fill='white'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19.594 5.916h-7.5v13h7.5a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-15 0h6v13h-6a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1m0-1.5a2.5 2.5 0 0 0-2.5 2.5v11a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-11a2.5 2.5 0 0 0-2.5-2.5zm1.5 5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2'
          />
        </mask>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.594 5.916h-7.5v13h7.5a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-15 0h6v13h-6a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1m0-1.5a2.5 2.5 0 0 0-2.5 2.5v11a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-11a2.5 2.5 0 0 0-2.5-2.5zm1.5 5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2'
          fill='white'
        />
        <path
          d='M12.094 5.916v-1h-1v1zm0 13h-1v1h1zm-1.5-13h1v-1h-1zm0 13v1h1v-1zm-4.5-9.5h1zm6-2.5h7.5v-2h-7.5zm1 12v-13h-2v13zm6.5-1h-7.5v2h7.5zm0 0v2a2 2 0 0 0 2-2zm0-11v11h2v-11zm0 0h2a2 2 0 0 0-2-2zm-9-2h-6v2h6zm1 14v-13h-2v13zm-7 1h6v-2h-6zm-2-2a2 2 0 0 0 2 2v-2zm0-11v11h2v-11zm2-2a2 2 0 0 0-2 2h2zm-1.5 2a1.5 1.5 0 0 1 1.5-1.5v-2a3.5 3.5 0 0 0-3.5 3.5zm0 11v-11h-2v11zm1.5 1.5a1.5 1.5 0 0 1-1.5-1.5h-2a3.5 3.5 0 0 0 3.5 3.5zm15 0h-15v2h15zm1.5-1.5a1.5 1.5 0 0 1-1.5 1.5v2a3.5 3.5 0 0 0 3.5-3.5zm0-11v11h2v-11zm-1.5-1.5a1.5 1.5 0 0 1 1.5 1.5h2a3.5 3.5 0 0 0-3.5-3.5zm-15 0h15v-2h-15zm2.5 4h-2a2 2 0 0 0 2 2zm0 0v2a2 2 0 0 0 2-2zm0 0h2a2 2 0 0 0-2-2zm0 0v-2a2 2 0 0 0-2 2zm0 3h-2a2 2 0 0 0 2 2zm0 0v2a2 2 0 0 0 2-2zm0 0h2a2 2 0 0 0-2-2zm0 0v-2a2 2 0 0 0-2 2zm-2 3a2 2 0 0 0 2 2v-2zm2-2a2 2 0 0 0-2 2h2zm2 2a2 2 0 0 0-2-2v2zm-2 2a2 2 0 0 0 2-2h-2z'
          fill='currentColor'
          mask='url(#path-1-inside-1_34544_90440)'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.594 5.916h-7.751v13h7.75a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-15-1.5a2.5 2.5 0 0 0-2.5 2.5v11a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-11a2.5 2.5 0 0 0-2.5-2.5zm1.5 5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2'
        fill='currentColor'
      />
    )}
  </IconBase>
);
